<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="getTitle"
  >

  <template v-slot:body>
    <h4>
      {{
        $t('organizations.users_section.modals.disable.message', {
          'numberOfAccounts': numberOfSelectedUsers
        })
      }}
    </h4>
  </template>
  <template v-slot:footer>
     <primary-button
      class="confirm-disable"
      ref="submitEditOrganizationUserButton"
      @click.native="handleSubmitDisableUsers"
    >
      {{$t('organizations.users_section.modals.disable.confirm')}}
    </primary-button>
    <tertiary-button @click.native="$emit('closed')">
      {{$t('organizations.users_section.modals.disable.cancel')}}
    </tertiary-button>
  </template>

  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'

  export default {
    props: {
      numberOfSelectedUsers: {
        type: Number,
        default: 0,
      },
    },
    components: {
      Modal,
      PrimaryButton,
      TertiaryButton,
    },
    computed: {
      getTitle() {
        return this.$t('organizations.users_section.modals.disable.title', {
          numberOfAccounts: this.numberOfSelectedUsers
        })
      }
    },
    methods: {
      handleSubmitDisableUsers() {
        this.$emit('closed')
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../scss/_colors.scss';

  h4 {
    text-align: left;
    font-weight: 500;
    font-size: 18px;
    color: $dark-blue-2;
  }

  .elsa-button.confirm-disable, .elsa-button.confirm-disable:hover {
    background: $orange;
    border-radius: 40px;
  }

</style>
